export const findMatch = (fields, options) => {
  const lowerFields = fields.map(f => f.toLowerCase());

  for (const option of options) {
    const lowerOption = option.toLowerCase();

    const matchIndex = lowerFields.findIndex(f => f.includes(lowerOption));
    if (matchIndex !== -1) {
      return fields[matchIndex];
    }
  }

  return null;
};

export const matchFields = (fields, matchers) => {
  const mappings = {};
  for (const [ key, names ] of Object.entries(matchers)) {
    mappings[key] = findMatch(fields, names);
  }
  return mappings;
}

export const hasInvalid = (data, column, test) => {
  if (!data || !column) return;
  return data
    .map(value => value[column])
    .some(value => test(value) === false)
}

export const check = (values, column, regex) => {
  if (!column) return;
  const profiles = values.data;
  return profiles
    .map(value => value[column])
    .some(value => !regex.test(value))
}

export const getColumn = (values, property) => values.columns && values.columns[property];
export const getData = (values, property) => values.data && values.data.some(data => data[property]);
